/**
 * TRAC-896: partial YMMV card.
 *
 * When ON, an agent `ymmv_interface` emit NEVER auto-opens the full-screen
 * Find Your Vehicle takeover. It renders an inline, tappable "partial YMMV
 * card" (a cropped slice of the real interface) alongside the turn's answer
 * text and any other cards. Tapping the card opens the EXISTING full-screen
 * YMMV machinery; dismissing it closes silently (no "No worries…" apology —
 * with no auto-open there is nothing to apologize for).
 *
 * When OFF, the pre-TRAC-896 behavior is restored verbatim: the emit
 * activates full-screen YMMV mode immediately and removes the turn's
 * assistant bubble.
 *
 * Kept as a kill switch, not an experiment. The card changes an interaction
 * five QA testers are about to hit for the first time; if it turns out ugly in
 * a sweep this is the one-line way back to known behavior without a revert.
 * Retire it once the card has been through QA. Frontend-only: the emit
 * contract, agent/backend, and pending_selector semantics are untouched.
 */
export const PARTIAL_YMMV_CARD_ENABLED = true;

